export const style = {
  wordBreak: 'break-all',
  margin: 0,
  whiteSpace: 'pre-line',
  wordWrap: 'break-word',
  width: '100%',
};
